import React from "react";
import { useFormContext } from "react-hook-form";

import { FormField } from "components/form/FormField/FormField";

import style from "../AddVaccineForm.module.css";

export const TextField = ({
  name,
  label,
  placeholder = "",
  type = "text",
  inputMode,
  wrapperClass,
  disabled = false,
  value: valueProp,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  onFocus: onFocusProp,
  required = false,
  /** Sets aria-required without appending * (use when label already ends with *) */
  ariaRequired = false,
}) => {
  const { register, watch } = useFormContext();

  const watchedValue = disabled ? watch(name) : undefined;
  const registered = register(name);

  const inputProps = disabled
    ? { value: valueProp ?? watchedValue ?? "", disabled: true }
    : {
        ...registered,
        onChange: (e) => {
          registered.onChange(e);
          onChangeProp?.(e);
        },
        onBlur: onBlurProp
          ? (e) => {
              registered.onBlur(e);
              onBlurProp(e);
            }
          : registered.onBlur,
        onFocus: onFocusProp
          ? (e) => {
              registered.onFocus?.(e);
              onFocusProp(e);
            }
          : registered.onFocus,
      };

  const input = (
    <input
      type={type}
      className="form-control"
      placeholder={placeholder}
      inputMode={inputMode}
      {...inputProps}
      aria-required={required || ariaRequired ? "true" : undefined}
    />
  );

  return (
    <FormField name={name}>
      <label className={style.pregnancyFormLabel}>
        {label}
        {required ? " *" : ""}
      </label>
      {wrapperClass ? (
        <div className={style[wrapperClass]}>{input}</div>
      ) : (
        input
      )}
    </FormField>
  );
};

export const TextAreaField = ({
  name,
  label,
  placeholder = "",
  rows = 3,
  maxLength,
}) => {
  const { register, watch } = useFormContext();

  const value = watch(name) || "";
  const limit = maxLength;

  return (
    <FormField name={name}>
      <label className={style.pregnancyFormLabel}>{label}</label>
      <div className={style.textAreaWrapper}>
        <textarea
          rows={rows}
          placeholder={placeholder}
          className="form-control"
          maxLength={limit}
          {...register(name)}
        />
        {limit && (
          <div className={style.charCounter}>
            {value.length}/{limit}
          </div>
        )}
      </div>
    </FormField>
  );
};
